module.exports = __webpack_public_path__ + "img/right-v2.6038856e.svg";